module.exports = __webpack_public_path__ + "static/media/3-Clubs.2c1ca104.svg";